import { render, staticRenderFns } from "./Controlbar.vue?vue&type=template&id=182ef4f2&"
import script from "./Controlbar.vue?vue&type=script&lang=js&"
export * from "./Controlbar.vue?vue&type=script&lang=js&"
import style0 from "./Controlbar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VSelect})
